function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import { css } from 'styled-components';
import { Box } from '@goodrx/matisse-react';
import { createComponent } from '../../utils';

const getPadding = p => typeof p.gutter === 'number' ? p.gutter : p.theme.gridGutter;

const StyledContainer = createComponent({
  name: 'Container',
  as: Box,
  style: ({
    maxWidth,
    fluid,
    theme
  }) => css`
    margin-left: auto;
    margin-right: auto;
    width: 100%;
    max-width: ${fluid ? '100%' : `${maxWidth || theme.gridWidth}px`};
    padding-left: ${getPadding}px;
    padding-right: ${getPadding}px;
  `
});
StyledContainer.displayName = 'Container';
export const Container = ({
  gutter,
  children,
  ...rest
}) => /*#__PURE__*/React.createElement(StyledContainer, _extends({
  gutter: gutter
}, rest), React.Children.map(children, child => {
  if ( /*#__PURE__*/React.isValidElement(child)) {
    return /*#__PURE__*/React.cloneElement(child, {
      gutter
    });
  }

  return child;
}));